module.exports = __webpack_public_path__ + "img/store-ecwid.204fce4f.svg";